import { render, staticRenderFns } from "./OrdersLocked.vue?vue&type=template&id=209e968e&scoped=true&"
import script from "./OrdersLocked.vue?vue&type=script&lang=js&"
export * from "./OrdersLocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209e968e",
  null
  
)

export default component.exports